/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { COST_REPORT_SOURCE_OPTIONS } from './costReportSource';

const CostReportSourceDropdown = (props: DefaultInputPropTypes<string>) => {
  const options = { ...COST_REPORT_SOURCE_OPTIONS };

  return <EnumDropdown options={options} placeholder="Select Type" {...props} />;
};

export default CostReportSourceDropdown;
